export const roomOptions = ['101', '102', '103', '201', '202'];

export const nilPerOralOptions = [
  "8 hours", "6 hours", "4 hours", "Overnight fasting"
];

export const wardOptions = ['Ward 1', 'Ward 2', 'Ward 3', 'ICU', 'General', 'Private'];

export const ivFluidsOptions = [
  "Normal Saline", "Ringer's Lactate", "Dextrose", "5% Dextrose", "DNS", "D5NS"
];

export const surgeryOptions = [
  "Appendectomy", "Cholecystectomy", "Hernia Repair", "C-Section", "Orthopedic Surgery"
];

export const anaesthesiaOptions = [
  "General Anaesthesia", "Spinal Anaesthesia", "Local Anaesthesia", "Epidural", "Sedation"
];

export const positionOptions = [
  "Supine", "Prone", "Lateral", "Lithotomy", "Trendelenburg"
];

export const oralLiquidsOptions = [
  "Water", "ORS (Oral Rehydration Solution)", "Juice", "Coconut Water", "Clear Broth", "Tea", "Milk"
];

export const dietOptions = [
  "Normal Diet", "Soft Diet", "Liquid Diet", "Diabetic Diet", "Low Salt Diet"
];

export const antibioticOptions = [
  'Amoxicillin', 'Ciprofloxacin', 'Azithromycin', 'Ceftriaxone', 'Metronidazole', 
  'Doxycycline', 'Clindamycin'
];

export const paracetamolOptions = [
  'Given', 'Not Given', '8 Hourly', '6 Hourly', '12 Hourly', 'As Required'
];

export const injUketOptions = [
  'B.D', 'SOS', 'Once Daily', 'Twice Daily', 'Thrice Daily', 'As Required'
];

export const concentrationOptions = [
  '0.0625%', '0.1%', '0.125%', '0.2%', '0.25%', '0.5%'
];

export const painAnalgesiaOptions = [
  'Paracetamol', 'NSAIDs', 'Morphine', 'Fentanyl', 'Tramadol', 'Other'
];

export const painScoreOptions = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', '10'];

export const doctorGroups = {
  Cardiologists: [
    "Dr. John Smith", "Dr. Emily Johnson", "Dr. Michael Brown", 
    "Dr. Sarah Davis", "Dr. William Wilson", "Dr. Linda Martinez"
  ],
  Neurologists: [
    "Dr. Robert Lee", "Dr. Patricia Taylor", "Dr. James Anderson", 
    "Dr. Barbara Thomas", "Dr. David Jackson", "Dr. Susan White"
  ],
  Orthopedics: [
    "Dr. Richard Garcia", "Dr. Jennifer Harris", "Dr. Charles Clark", 
    "Dr. Jessica Lewis", "Dr. Thomas Robinson", "Dr. Karen Walker"
  ],
  Dermatologists: [
    "Dr. Nancy Young", "Dr. Matthew Hall", "Dr. Donna Allen", 
    "Dr. Steven King", "Dr. Michelle Wright", "Dr. George Scott"
  ],
  Gynecologists: [
    "Dr. Sandra Green", "Dr. Kevin Adams", "Dr. Laura Baker", 
    "Dr. Mark Nelson", "Dr. Angela Carter", "Dr. Brian Mitchell"
  ],
  Pediatricians: [
    "Dr. Melissa Perez", "Dr. Eric Roberts", "Dr. Deborah Turner", 
    "Dr. Jason Phillips", "Dr. Rebecca Campbell", "Dr. Andrew Parker"
  ],
  AnaesthesiaSpecialists: [
    "Dr. Anil Mehta", "Dr. Priya Iyer", "Dr. Rakesh Nair", 
    "Dr. Neha Sharma", "Dr. Vivek Rao", "Dr. Aarti Desai"
  ]
};

export const medicationOptions = [
  "Paracetamol 500mg", "Ibuprofen 400mg", "Metformin", "Aspirin", 
  "Lisinopril", "Other medication"
];

export const insulinOrderOptions = [
  "Rapid-acting insulin", "Long-acting insulin", "Sliding scale insulin", 
  "Insulin pump", "Other insulin orders"
];

export const bloodTransfusionOptions = [
  'No transfusion needed', 'Type and Crossmatch done', 'Packed Red Blood Cells', 
  'Fresh Frozen Plasma', 'Platelets', 'Cryoprecipitate', 'Other'
];

export const opinionOptions = [
  'No additional opinion needed', 'Consult cardiology', 'Consult pulmonology', 
  'Further imaging required', 'Repeat lab tests'
];

export const queriesOptions = [
  'Clarify medication doses', 'Discuss postoperative care', 
  'Ask about follow-up schedule', 'Discuss possible complications'
];

export const intakeOutputOptions = [
  'Monitor hourly', 'Record every 4 hours', 'IV fluids ongoing', 
  'Oral intake resumed', 'Strict input/output charting'
];

export const nurseOptions = [
  'Nurse John Doe - ID 123', 'Nurse Jane Smith - ID 456', 'Nurse Emily Johnson - ID 789'
];

export const bloodInvestigationOptions = [
  "Complete Blood Count (CBC)", "Blood Sugar", "Liver Function Test", 
  "Kidney Function Test", "Coagulation Profile", "Electrolytes"
];
